import { RoundIndex } from "../components/Slider"
import { useRound } from "./useRound"
import { useRoundIndex } from "./useRoundIndex"

export const useActiveSlide = (round?: number, index?: RoundIndex) => {
	const currentRound = useRound()
	const currentIndex = useRoundIndex()
	return currentRound === round && currentIndex === index
}
